module.exports = __webpack_public_path__ + "static/img/slider-2.ae79ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-2.jpg
// module id = eNkB
// module chunks = 7